module.exports = __webpack_public_path__ + "img/bird-5-left.8142fc2e.png";